/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Container, Table } from "reactstrap";
import { isArtLocation } from "../../../../../actions/Layers/constants";
import useConfig from "../../../../../actions/Tenants/config/configHook";
import { useLayerChecks } from "../../../../../hooks/useLayerChecks";
import { TenantDefect, useTenantDefectDefinitions } from "../../../../Forms/useManagedOptionsHook";
import { Loading } from "../../../../Helper/Loading";
import { useQcEntities } from "../../QcEntityContext";
import { RipeningDay } from "./RipeningDay";

interface DayInfo {
    day: number;
    check: boolean;
    check_id?: number
}

export const AdvanceRipeningChecks = ({ highlight_current = false }: { highlight_current?: boolean }) => {
    const { check, layer } = useQcEntities();
    const config = useConfig();
    const location = config.get_check_type_config(layer, check);

    const tenantDefectDefinitions = useTenantDefectDefinitions(layer.fruit_type);

    // * Fetch checks for this art location using TanStack Query
    // * Only fetch if we're in an art location (advanced ripening)
    const isArtCheck = isArtLocation(check?.location);
    const { data: checks = [] } = useLayerChecks(
        layer?.tenant_id,
        isArtCheck ? layer?.id : undefined,
        isArtCheck ? { check_location: check?.location } : {},
    );

    if (!checks || !location?.summary_fruit_fields) {
        return <Loading />;
    }

    // * min width of table cell is 1320/7 = ~188px
    const filteredChecks = checks.filter((i) => i.location === check.location).sort((a, b) => a.check_id - b.check_id);
    const days: DayInfo[] = [1, 2, 3, 4, 5, 6, 7].map((i) => (filteredChecks[i - 1] ? { check_id: filteredChecks[i - 1].check_id, day: i, check: true } : { day: i, check: false }));

    return (
        <Container>
            <div className="mx-n2">
                <Table responsive borderless>
                    <tbody>
                        <tr>
                            {days.map((day) => <td key={day.day} className="p-0 px-2" css={css`min-width: 184px;`}>
                                <RipeningDay
                                    highlight_current={highlight_current}
                                    day={day.day}
                                    check_id={day?.check_id || false}
                                    tenantDefectDefinitions={tenantDefectDefinitions as TenantDefect[]}
                                />
                            </td>)}
                        </tr>
                    </tbody>
                </Table>
            </div>
        </Container>
    );
};
